import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DesktopSharingStatus = 'local' | 'remote' | 'none';

type ScreenSharingState = {
    desktopSharingStatus: DesktopSharingStatus; // Статус приходит из голума (slotsChanged), а где-то выставляем и мы, запустил ли текущий пользователь шаринг, или другой пользователь, или шаринг не запущен (local, remote, none)
    isDesktopSharingEnabled?: boolean; // Возможен ли шаринг на устройстве
    displayMediaStatus?: boolean; // Статус шаринга пришедший из голума (displayMediaStarted,displayMediaStopped), эти события приходят из голума когда мы включили шаринг и соответственно выключили
    isSharingStarting: boolean; // Статус который говорит о том что пользователь находится в процессе выбора окна для шаринга
};
const initialState: ScreenSharingState = {
    desktopSharingStatus: 'none',
    isSharingStarting: false,
};

const screenSharingSlice = createSlice({
    name: 'screenSharing',
    initialState,
    reducers: {
        resetScreenSharing() {
            return initialState;
        },
        setIsDesktopSharingEnabled(state, action: PayloadAction<boolean>) {
            state.isDesktopSharingEnabled = action.payload;
        },
        setStoreDesktopSharingStatus(state, action: PayloadAction<DesktopSharingStatus>) {
            state.desktopSharingStatus = action.payload;
        },
        setDisplayMediaStatus(state, action: PayloadAction<boolean>) {
            state.displayMediaStatus = action.payload;
        },
        setIsSharingStarting(state, action: PayloadAction<boolean>) {
            state.isSharingStarting = action.payload;
        },
    },
});

export const shareScreenAction = createAction<string | undefined>('conference/screenSharing/shareScreen');
export const unshareScreenAction = createAction<void>('conference/screenSharing/unshareScreen');
export const {
    resetScreenSharing,
    setIsDesktopSharingEnabled,
    setStoreDesktopSharingStatus,
    setDisplayMediaStatus,
    setIsSharingStarting,
} = screenSharingSlice.actions;
export const screenSharingReducer = screenSharingSlice.reducer;
